import withBaseComponent from './universal/partials/withBaseComponent';
import { SERVICES } from './universal/utils/constants';

export default {
  withBaseComponent,
  SERVICES
};
